import React, { createContext, useEffect, useReducer } from 'react';
import { fb } from '../utils/Firebase';
import { CircularProgress } from '@material-ui/core';
import { authReducer } from '../reducers/authReducer';

export const AuthContext = createContext();

const initialState = {
    authReady: false,
    isLogged: false
}

const Auth = props => {

    const [ state, dispatch ] = useReducer(authReducer, initialState);
    const { authReady, isLogged } = state;
    const { children } = props;

    useEffect(() => {
        fb.auth().onAuthStateChanged(user => {
            user ? dispatch({ type: 'add', payload: { isLogged: true } }) : dispatch({ type: 'add', payload: { isLogged: false } });
            dispatch({ type: 'add', payload: { authReady: true } });
        })
    }, []);

    if(!authReady) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <CircularProgress color='primary' />
            </div>
        );
    }

    return (
        <AuthContext.Provider value={{ isLogged }}>
            { children }
        </AuthContext.Provider>
    );
}

export default Auth;